<form [formGroup]="form" (ngSubmit)="submitForm()">
  <h2 mat-dialog-title>{{ title }}</h2>
  <mat-dialog-content>
    <sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button color="warn" mat-button mat-dialog-close>{{ cancelButton }}</button>
    <button [disabled]="form.invalid" type="submit" color="success" mat-button>
      {{ submitButton }}
    </button>
  </mat-dialog-actions>
</form>
